export default "__VITE_ASSET__C43qp3kp__"